import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http, settings } from '../../utils/config';

const initialState = {
    options : [],
    isLoadCategory: false,
    brand: [],
    isLoadBrand: false,
    categoryError: null,
    brandError: null,
    logisticsChannels: [],
    isLoadChannels: false,
    channelsError: null,
}
export const getCategoryShopee = createAsyncThunk(
    'Shopee/getCategoryShopee',
    async (accessToken, { rejectWithValue }) => {
        const response = await http.get(
            `/get-category-shopee?access_token=${accessToken}&shop_id=${settings.getCookie("shopId")}`
        );
        const payload = response.data;

        // Backend trả lỗi Shopee (status 424 from Helpers::shopeeResponse)
        if (payload?.status === 424) {
            return rejectWithValue(payload.data?.message_vi || payload.message || 'Lỗi tải danh mục');
        }

        const categories = payload?.data;
        return Array.isArray(categories) ? categories : [];
    }
);
export const getBrandShopee = createAsyncThunk(
    'Shopee/getBrandShopee',
    async ({ Token_Brand, category_id }, { rejectWithValue }) => {
      const response = await http.get(
        `/get-brand-shopee?shop_id=${settings.getCookie("shopId")}&access_token=${Token_Brand}&category_id=${category_id}&offset=0&page_size=20&status=1`
      );
      const payload = response.data;

      if (payload?.status === 424) {
        return rejectWithValue(payload.data?.message_vi || payload.message || 'Lỗi tải thương hiệu');
      }

      const brandData = payload?.data?.response?.brand_list;
      if (!Array.isArray(brandData)) return [];

      return brandData.map((brand) => ({
        value: brand.brand_id,
        label: brand.display_brand_name,
      }));
    }
  );

/** Chuẩn hóa 1 item từ API (số hoặc object) thành { logistic_id, logistic_name } */
function normalizeLogisticsChannel(item) {
    if (item == null) return null;
    if (typeof item === 'number') {
        return { logistic_id: item, logistic_name: `Đơn vị vận chuyển #${item}` };
    }
    if (typeof item !== 'object') return null;
    const id = item.logistic_id ?? item.logistics_channel_id ?? item.channel_id ?? item.id;
    const name = item.logistic_name ?? item.logistics_channel_name ?? item.channel_name ?? item.name ?? item.display_name;
    if (id === undefined || id === null) return null;
    return {
        logistic_id: Number(id),
        logistic_name: name && String(name).trim() ? String(name) : `Đơn vị vận chuyển #${id}`,
    };
}

export const getChannelListShopee = createAsyncThunk(
    'Shopee/getChannelListShopee',
    async (_, { rejectWithValue }) => {
        const access_token = settings.getCookie('access_token');
        const shop_id = settings.getCookie('shopId');
        if (!access_token || !shop_id) {
            return rejectWithValue('Chưa đăng nhập Shopee');
        }
        const response = await http.get(
            `/get-channel-list-shopee?access_token=${encodeURIComponent(access_token)}&shop_id=${encodeURIComponent(shop_id)}`
        );
        const payload = response.data;
        if (payload?.status === 424) {
            return rejectWithValue(payload.data?.message_vi || payload.message || 'Không tải được danh sách đơn vị vận chuyển');
        }
        const raw = payload?.data;
        const list = raw?.response?.logistics_channel_list ?? raw?.logistics_channel_list ?? [];
        if (!Array.isArray(list)) return [];
        return list.map(normalizeLogisticsChannel).filter(Boolean);
    }
);

const getCategory = createSlice({
    name: "getCategory",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCategoryShopee.pending, (state) => {
                state.isLoadCategory = true;
                state.categoryError = null;
            })
            .addCase(getCategoryShopee.fulfilled, (state, action) => {
                state.options = Array.isArray(action.payload) ? action.payload : [];
                state.isLoadCategory = false;
                state.categoryError = null;
            })
            .addCase(getCategoryShopee.rejected, (state, action) => {
                state.isLoadCategory = false;
                state.options = [];
                state.categoryError = action.payload || 'Không tải được danh mục Shopee.';
            })
            //get brand
            .addCase(getBrandShopee.pending, (state) => {
                state.isLoadBrand = true;
                state.brandError = null;
            })
            .addCase(getBrandShopee.fulfilled, (state, action) => {
                state.brand = Array.isArray(action.payload) ? action.payload : [];
                state.isLoadBrand = false;
                state.brandError = null;
            })
            .addCase(getBrandShopee.rejected, (state, action) => {
                state.isLoadBrand = false;
                state.brand = [];
                state.brandError = action.payload || 'Không tải được thương hiệu.';
            })
            .addCase(getChannelListShopee.pending, (state) => {
                state.isLoadChannels = true;
                state.channelsError = null;
            })
            .addCase(getChannelListShopee.fulfilled, (state, action) => {
                state.logisticsChannels = Array.isArray(action.payload) ? action.payload : [];
                state.isLoadChannels = false;
                state.channelsError = null;
            })
            .addCase(getChannelListShopee.rejected, (state, action) => {
                state.logisticsChannels = [];
                state.isLoadChannels = false;
                state.channelsError = action.payload || 'Không tải được đơn vị vận chuyển.';
            })
    },
});

// export const { } = getCategory.actions

export default getCategory.reducer